import { Box, Center, Flex, Spacer, Stack, Text } from '@chakra-ui/react'
import { ScoreWithRef, ScoreState } from '../types'

// Define the props interface for the component
interface ScoreDescProps {
  score: ScoreWithRef
  scoreState: ScoreState
}

function ScoreDesc({ score, scoreState }: ScoreDescProps) {
  const classValue =
    score.inputLevel || score.classifiedLevel || score.classified_level || score.level || ''

  return (
    <Stack spacing="2">
      <>
        <Flex>
          <Text>Path: </Text>
          <Spacer />
          <Text>{score.inputPath || score.path}</Text>
        </Flex>
        <Flex>
          <Text>Song: </Text>
          <Spacer />
          <Text>
            {(score.inputArtist || score.classifiedArtist) +
              ' - ' +
              (score.inputSong || score.classifiedSong)}
          </Text>
        </Flex>
        <Flex>
          <Text>Class: </Text>
          <Spacer />
          <Text>{classValue}</Text>
        </Flex>
        <Flex>
          <Text>Accuracy: </Text>
          <Spacer />
          <Text>{score.inputAccuracy || score.accuracy}</Text>
        </Flex>
        <Flex>
          <Text>Longest streak: </Text>
          <Spacer />
          <Text>{score.inputLongestStreak || score.longestStreak}</Text>
        </Flex>
        <Flex>
          <Text>Absolute score: </Text>
          <Spacer />
          <Text>{score.inputAbsoluteScore || score.absoluteScore}</Text>
        </Flex>
        <Center>
          <Text>----- DEBUG INFO -----</Text>
        </Center>

        <Flex>
          <Text>Status:</Text>
          <Spacer />
          <Text fontWeight={600}>{scoreState.value}</Text>
        </Flex>
        <Box fontSize={10}>
          <>
            <Flex>
              <Text>Extracted: </Text>
              <Spacer />
              <Text>
                {score.extractedArtist} - {score.extractedSong}
              </Text>
            </Flex>
            <Flex>
              <Text>Classified: </Text>
              <Spacer />
              <Text>
                {score.classifiedArtist} - {score.classifiedSong}
              </Text>
            </Flex>
            <Flex justifyContent="flex-end">
              <Text as="i">({score.classifiedArtistConfidence})</Text>{' '}
            </Flex>
            <Flex>
              <Text>Language detected: </Text>
              <Spacer />
              <Text>{score.language}</Text>
            </Flex>
            <Flex>
              <Text>Score status FB: </Text>
              <Spacer />
              <Text>{score.status}</Text>
            </Flex>
          </>

          <Text>{score.recognitionStatusNotes}</Text>
        </Box>
      </>
    </Stack>
  )
}

export default ScoreDesc
